import FormErrorMessage from '@/features/form/components/ErrorMessage'
import {
    FormKeys,
    FormPhoneKeys,
} from '@/features/pos/components/CustomerProfile/form/constants/keys'
import ValidationMessage from '@/features/pos/components/CustomerProfile/parts/FormContent/parts/ValidationMessage'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const PhoneValidationMessage: FC = () => {
    const { t } = useTranslation()

    return (
        <FormErrorMessage
            name={FormKeys.Phone}
            pathPriority={[FormPhoneKeys.Number]}
            render={(message) => <ValidationMessage message={t(message as any)} status="error" />}
        />
    )
}

export default PhoneValidationMessage
